/**
 * ⟦C62 · lot atelier · friction 7⟧ **« Les chiffres du tour » : le jargon, derrière « Les dessous ».**
 *
 * L'écran de consigne d'un mini-jeu disait « exigence E0 », « 92 BPM », « fenêtre 234 ms », « score
 * plafonné à 85 » : des mesures de réglage, sans explication, à l'endroit où le joueur ne veut qu'une
 * chose, jouer. Elles n'ont pas disparu : elles tiennent ici, en lignes, dans les dessous de la consigne
 * (`DessousMiniJeu`). L'écran garde ce qui se joue : combien de blocs, de cuts, de prises, de secondes.
 */

import { DessousBloc, DessousLignes } from "../../components/LesDessous";

export function BlocChiffresDuTour({ lignes }: { lignes: readonly string[] }) {
  if (lignes.length === 0) return null;
  return (
    <DessousBloc titre="Les chiffres du tour">
      <DessousLignes lignes={lignes.map((texte) => ({ icone: "🔢", texte }))} />
    </DessousBloc>
  );
}
